import React from "react";
import { Pagination, Stack } from "@mui/material";

export default function PaginationComponent({ count, page, onChange }) {
  return (
    <Stack
      spacing={2}
      direction="row"
      justifyContent="center"
      // mt={2}
      sx={{
        backgroundColor: "#E9EAEB",
        p: 0.7,
        borderRadius: "8px",
        boxShadow: "none",
        width: "100%",
      }}
    >
      <Pagination
        count={Math.ceil(count)}
        page={page}
        onChange={onChange}
        shape="rounded"
        showFirstButton
        showLastButton
        sx={{
          "& .MuiPaginationItem-root": {
            color: "black",
            fontWeight: "bold",
            borderRadius: "8px",
            border: "1px solid #ccc",
            height: "28px",
            minWidth: "28px",
            backgroundColor: "white",
            cursor: "pointer",
          },
          "& .Mui-selected": {
            backgroundColor: "#0B4C90",
            color: "white",
            border: "none",
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor: "#e0e0e0",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "#0B4C90",
          },
        }}
      />
    </Stack>
  );
}
